// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__n04M3","insightsList":"newBusinessInsightsMenu_insightsList__2Lbkn","active":"newBusinessInsightsMenu_active__1GLpu"};